module.exports = __webpack_public_path__ + "img/1.2fa38459.jpg";